import React from 'react'

const Footer = () => {
    return (
        <React.Fragment>

            <footer className="footer text-center">
                All Rights Reserved by UGONSA. Designed and Developed by
                <a href="https://idealab.com.ng/"> IdeaLab</a>.
            </footer>
            
        </React.Fragment>
    )
}

export default Footer
